import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSelectEntityItems, UseSelectEntityItemsReturnValue } from '../useSelectEntityItems/useSelectEntityItems';

/**
 * A variant for useSelectEntityItems which supports null values.
 */
export function useNullableSelectEntityItems(t0) {
  const $ = _c(15);
  const {
    value,
    entities,
    nullValueText,
    entityNotFoundText,
    getDisplayTextOfEntity,
    getKeyOfEntity,
    getValueOfEntity,
    onValueChanged
  } = t0;
  let t1;
  if ($[0] !== getValueOfEntity) {
    t1 = entity => {
      if (entity === null) {
        return null;
      }
      return getValueOfEntity(entity);
    };
    $[0] = getValueOfEntity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getValueOfEntityOrNull = t1;
  let t2;
  if ($[2] !== getDisplayTextOfEntity || $[3] !== nullValueText) {
    t2 = entity_0 => {
      if (entity_0 === null) {
        return nullValueText;
      }
      return getDisplayTextOfEntity(entity_0);
    };
    $[2] = getDisplayTextOfEntity;
    $[3] = nullValueText;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getDisplayTextOfEntityOrNull = t2;
  let t3;
  if ($[5] !== getKeyOfEntity) {
    t3 = entity_1 => {
      if (entity_1 === null) {
        return "useNullableSelectEntityItems.nullValue";
      }
      return getKeyOfEntity(entity_1);
    };
    $[5] = getKeyOfEntity;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getKeyOfEntityOrNull = t3;
  let t4;
  if ($[7] !== entities || $[8] !== entityNotFoundText || $[9] !== getDisplayTextOfEntityOrNull || $[10] !== getKeyOfEntityOrNull || $[11] !== getValueOfEntityOrNull || $[12] !== onValueChanged || $[13] !== value) {
    t4 = {
      value,
      entities,
      entityNotFoundText,
      onValueChanged,
      getValueOfEntity: getValueOfEntityOrNull,
      getKeyOfEntity: getKeyOfEntityOrNull,
      getDisplayTextOfEntity: getDisplayTextOfEntityOrNull
    };
    $[7] = entities;
    $[8] = entityNotFoundText;
    $[9] = getDisplayTextOfEntityOrNull;
    $[10] = getKeyOfEntityOrNull;
    $[11] = getValueOfEntityOrNull;
    $[12] = onValueChanged;
    $[13] = value;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useSelectEntityItems(t4);
}
export type UseNullableSelectEntityItemsOptions<TEntity, TValue> = {
  value: TValue | null;
  /**
   * the null value should only occur once
   */
  entities: Array<TEntity | null>;
  nullValueText: string;
  entityNotFoundText: string;
  onValueChanged: (value: TValue | null) => void;
  getDisplayTextOfEntity: (entity: TEntity) => string;
  getKeyOfEntity: (entity: TEntity) => string;
  getValueOfEntity: (entity: TEntity) => TValue;
};
export type UseNullableSelectEntityItemsReturnValue<TEntity> = UseSelectEntityItemsReturnValue<TEntity | null>;